import { TWebUser } from "@letshang/constants"
import { applyActionCode } from "firebase/auth"
import { deleteDoc, doc } from "firebase/firestore"
import {
  deleteObject,
  getDownloadURL,
  ref,
  ref as storageRef,
  uploadBytesResumable,
} from "firebase/storage"

import { auth } from "@firebaseConfig/clientApp"
import { storage } from "@firebaseConfig/clientApp"

function handleVerifyEmail(actionCode: any) {
  return new Promise((res, rej) => {
    applyActionCode(auth, actionCode)
      .then((resp) => {
        // Email address has been verified.
        res(resp)
      })
      .catch((error) => {
        rej(error)
      })
  })
}

const uploadImage = async (
  uri: string,
  path: string,
  user: TWebUser,
): Promise<string> => {
  try {
    console.log("** Uri from picker **", uri)

    // Fetch the image and convert it to a Blob
    const fetchResponse = await fetch(uri)
    const theBlob = await fetchResponse.blob()

    // Validate user ID
    if (!user?.uid) {
      throw new Error("User ID is missing.")
    }

    // Define the full path for storage
    const fullPath = `${user?.uid}/${path}`
    const storageRef = ref(storage, fullPath)

    // Return a Promise to handle the upload process
    return new Promise((resolve, reject) => {
      // Check if the blob is valid
      if (!theBlob || theBlob.size === 0) {
        console.log("No file to upload or file is empty.")
        reject("No file to upload or file is empty.")
        return
      }

      // Start the upload process
      const uploadTask = uploadBytesResumable(storageRef, theBlob)

      // Track upload progress
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          )
          console.log("Upload progress:", percent + "%")
        },
        (err) => {
          console.log("Error uploading image:", err)
          reject(err)
        },
        async () => {
          // Get the download URL once upload is complete
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
          console.log("File available at:", downloadURL)
          resolve(downloadURL) // Resolve the URL
        },
      )
    })
  } catch (err) {
    console.error("Error during image upload:", err)
    throw err
  }
}

const uploadImageToPath = async (
  uri: string,
  path: string,
  userId: string,
): Promise<string> => {
  try {
    console.log("** Uri from picker **", uri)
    console.log("** user **", userId)

    // Fetch the image and convert it to a Blob
    const fetchResponse = await fetch(uri)
    const theBlob = await fetchResponse.blob()

    // Validate user ID
    if (!userId) {
      throw new Error("User ID is missing.")
    }

    // Define the full path for storage
    const fullPath = `${path}`
    const storageRef = ref(storage, fullPath)

    // Return a Promise to handle the upload process
    return new Promise((resolve, reject) => {
      // Check if the blob is valid
      if (!theBlob || theBlob.size === 0) {
        console.log("No file to upload or file is empty.")
        reject("No file to upload or file is empty.")
        return
      }

      // Start the upload process
      const uploadTask = uploadBytesResumable(storageRef, theBlob)

      // Track upload progress
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          )
          console.log("Upload progress:", percent + "%")
        },
        (err) => {
          console.log("Error uploading image:", err)
          reject(err)
        },
        async () => {
          // Get the download URL once upload is complete
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
          console.log("File available at:", downloadURL)
          resolve(downloadURL) // Resolve the URL
        },
      )
    })
  } catch (err) {
    console.error("Error during image upload:", err)
    throw err
  }
}

/**
 * Deletes an image from Firebase Storage by its full path.
 * @param {string} path - The full path to the image in storage (e.g., 'events/eventId/plugins/pluginId/filename.jpg')
 * @returns {Promise<void>}
 */
export const deleteImageFromStorage = async (path: string): Promise<void> => {
  if (!path) throw new Error("No storage path provided for deletion.")
  const imgRef = storageRef(storage, path)
  await deleteObject(imgRef)
}

export { handleVerifyEmail, uploadImage, uploadImageToPath }
